module.exports = "/fonts/vendor/material-design-icons-icondist/MaterialIcons-Regular.woff?08cefa1bc6566a650da7a34ac66e39aa";